export default function (schema) {
  if (!(schema !== null && schema !== void 0 && schema.properties)) return {};
  return Object.keys(schema.properties).reduce((obj, prop) => {
    var _schema$properties;
    if (((_schema$properties = schema.properties) === null || _schema$properties === void 0 ? void 0 : _schema$properties[prop].default) !== undefined) obj[prop] = schema.properties[prop].default;
    return obj;
  }, {});
}